import React from 'react'
import logUtil from 'utils/log'
import Flex from 'components/Flex'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import ButtonLink from 'components/ButtonLink'
import { ROUTE_PATH } from 'modules/route/constants'
import './index.css'
import setShouldScrollToReferAFriendAfterSignInUtil from 'pages/Squad/utils/set-scroll-to-refer-a-friend-after-sign-in'

const INVITE_A_FRIEND_TO_YOUR_SQUAD = 'Invite a friend to your squad'

const ANALYTICS_EVENT = {
  INVITE_A_FRIEND_TO_YOUR_SQUAD: 'INVITE_A_FRIEND_TO_YOUR_SQUAD'
}

export default function SquatPageInviteAFriendBottomButtonContent (props) {
  const debugProps = {
    props
  }

  logUtil('SquatPageInviteAFriendBottomButtonContent').debug('debugProps=', debugProps)

  const handleClick = () => {
    logUtil('SquatPageInviteAFriendBottomButtonContent#handleClick').debug('[start]')
    logEventAnalyticsUtil(ANALYTICS_EVENT.INVITE_A_FRIEND_TO_YOUR_SQUAD)
    setShouldScrollToReferAFriendAfterSignInUtil()
  }

  if (!props.isMediumScreen) {
    return <></>
  }
  return (
    <Flex className='squad-invite-a-friend-bottom-button'>
      <ButtonLink onClick={handleClick} href={ROUTE_PATH.ACCOUNT_LOYALTY}>
        {INVITE_A_FRIEND_TO_YOUR_SQUAD}
      </ButtonLink>
    </Flex>
  )
}
